export default __webpack_public_path__ + "static/Story_Image_4_650x650px-76a116c7b9422709ce0db4ca9843dc23.png";